export default {"src":"/_next/static/media/google.cdba6741.svg","height":38,"width":150};